import { CtaLink } from "../CtaLink";
import { ParallaxLayer } from "../motion/ParallaxLayer";
import { Reveal } from "../motion/Reveal";

/** Dernier appel, à l'encre : créer un compte ou comparer les offres. */
export function FinalCTA() {
  return (
    <section className="px-4 pb-20 sm:px-6 lg:px-8 lg:pb-28">
      <div className="relative mx-auto max-w-[1200px] overflow-hidden rounded-sheet bg-brand-gradient px-6 py-16 text-center text-primary-foreground sm:px-12 lg:py-24">
        {/* Les feuilles du logo, glissées dans les coins : au défilement,
            elles viennent s'y ranger, chacune de son côté. */}
        <ParallaxLayer
          distance={-70}
          className="pointer-events-none absolute -bottom-24 -left-20 h-64 w-52"
        >
          <div className="h-full w-full rotate-[-12deg] rounded-sheet bg-logo-sheet-back opacity-20" />
        </ParallaxLayer>
        <ParallaxLayer
          distance={70}
          className="pointer-events-none absolute -top-28 -right-16 h-64 w-52"
        >
          <div className="h-full w-full rotate-[10deg] rounded-sheet bg-logo-sheet-front opacity-15" />
        </ParallaxLayer>
        <Reveal className="relative mx-auto max-w-[40rem]">
          <h2 className="font-display text-[clamp(2.1rem,4.4vw,3.6rem)] leading-[1.05] font-semibold tracking-[-0.018em] text-balance">
            Demain matin, sachez{" "}
            <span className="text-action-on-primary">
              qui relancer
            </span>
            .
          </h2>
          <p className="mx-auto mt-5 max-w-[34rem] text-lg leading-relaxed text-primary-foreground-muted">
            Créez votre compte, puis connectez Pennylane pour retrouver vos factures.
            Ajoutez Gmail lorsque vous êtes prêt à envoyer votre première relance.
          </p>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <CtaLink to="/signup" variant="onDark" arrow>
              Créer un compte
            </CtaLink>
            <CtaLink to="/tarifs" variant="outlineOnDark">
              Voir les tarifs
            </CtaLink>
          </div>
          <p className="mt-6 text-caption text-primary-foreground-subtle">
            Création gratuite · Sans carte bancaire · Vous gardez la main sur chaque envoi
          </p>
        </Reveal>
      </div>
    </section>
  );
}
